import { render, staticRenderFns } from "./SPP.vue?vue&type=template&id=40a61e9e&scoped=true&"
import script from "./SPP.vue?vue&type=script&lang=js&"
export * from "./SPP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a61e9e",
  null
  
)

export default component.exports